import AppInput from '@nxsys/components/AppInputSearch';
import AppMenuFilter from '@nxsys/components/AppMenuFilter';
import FilterModal from './FilterModal';
import { useCallback, useState } from 'react';
import { AppState } from '@nxsys/store';
import { useSelector } from 'react-redux';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { GetAEPNListParams } from '@nxsys/store/slices/aepn/types';
import { debounce } from 'lodash';

type ActionsHeaderProps = {
  onFilter: (params: GetAEPNListParams) => void;
  hideAdvancedFilter?: boolean;
  onChangeCompanyIds?: (companyIds: string[]) => void;
};

export const ActionsHeader = ({
  onFilter,
  hideAdvancedFilter = false,
  onChangeCompanyIds,
}: ActionsHeaderProps) => {
  const { messages } = useTypedIntl();

  const { aepnList: { queryParams } } = useSelector(
    (state: AppState) => state.aepnStore,
  );

  const [openFilter, setOpenFilter] = useState(false);

  const [searchValue, setSearchValue] = useState('');

  const toggleFilter = () => {
    setOpenFilter(!openFilter);
  }

  const debouncedFetchData = useCallback(
    debounce((search: string) => {
      onFilter({
        ...queryParams,
        page: 0,
        search,
      });
    }, 500),
    [queryParams],
  );


  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchValue(value);
    debouncedFetchData(value);
  };

  return (
    <div className="flex items-center gap-2">
      <AppInput value={searchValue} onChange={handleSearchChange} />
      {!hideAdvancedFilter && (
        <AppMenuFilter options={[]} onChange={() => {}} onClick={toggleFilter} />
      )}
      {/* Kept mounted on the Upload tab so its form still shows the filters the
          list keeps applying (the employer lives on in the listing) */}
      <FilterModal
        isOpen={openFilter}
        toggle={toggleFilter}
        title={messages['common.filter']}
        onFilter={onFilter}
        onChangeCompanyIds={onChangeCompanyIds}
      />
    </div>
  );
};
